import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { VIEW_ROLE } from "../../query/ViewRole";
const BusinessBanner = ({ data }) => {
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  return userRole?.users[0].role==="business" ? (<div className="council-banner">
    <div className="council-banner-img">
      {data?.users[0]?.business_profile?.business_cover_photo && (
        <img
          src={data?.users[0]?.business_profile?.business_cover_photo}
          alt="council banner"
        />
      )}
    </div>
  </div>) :(
  <div className="council-banner">
  <div className="council-banner-img">
    {data?.users[0]?.club_profile?.cover_photo && (
      <img
        src={data?.users[0]?.club_profile?.cover_photo}
        alt="council banner"
      />
    )}
  </div>
</div>
  )
};

export default BusinessBanner;
